import { useState } from 'react';
import { FAIcon, GenericLink, useBreakpoint, Breakpoints, useSession } from '@nextgen-web-framework/all';
import { MiniCart } from '@commerce-cart-webcomponents/ui';
import { SearchBar } from '@commerce-search-webcomponents/ui';
import { SearchOverlay } from '@commerce-search-webcomponents/ui-composite';
import {
  HeaderItems,
  getAccountTypeData,
  SearchCloseButton,
  NavigationBar,
  SiteLogo,
  transformNavigationMenu,
  transformSiteLogo,
} from '@commerce-webcomponents/ui';
import MePanelDrawer from '../MePanelDrawer/MePanelDrawer';
import { LocationSelector } from '../LocationSelector/LocationSelector';
import { SiteHeaderProps } from './types/propsType';
import styles from './SiteHeader.module.scss';

const SiteHeader = ({
  data,
  onMePanelClick,
  tabletScrolled,
  headerBody,
  hasTabletScrolledHeaderBody,
  onSuggestionClick,
  activeRoute,
  langHandler,
  locale,
  cartListId,
  isLoggedIn,
}: SiteHeaderProps) => {
  const [showSearchOverlay, setShowSearchOverlay] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const viewPortType = useBreakpoint() as Breakpoints;
  const mobileView = [Breakpoints.XS, Breakpoints.SM].includes(viewPortType);
  const { session } = useSession();
  const overlayCloseHandler = () => {
    setSearchText('');
    setShowSearchOverlay(false);
  };
  const suggestionHandler = (
    e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element> | undefined,
    text: string,
  ) => {
    onSuggestionClick(e, text);
    setShowSearchOverlay(false);
  };

  const navigationBarData = transformNavigationMenu({
    ...getAccountTypeData(data.mega_menu_navigation, session.type),
    activeRoute: activeRoute,
  });
  const siteLogoData = transformSiteLogo(data.logo);

  return (
    <div className={showSearchOverlay ? styles['search-overlay-header-wrapper'] : ''}>
      <header
        className={!showSearchOverlay ? styles['header-wrapper'] : styles['search-overlay-header']}
        data-testid="siteHeader-test-id"
      >
        <div className={styles['header-left-nav']}>
          {[Breakpoints.MD].includes(viewPortType) &&
          !showSearchOverlay &&
          tabletScrolled &&
          headerBody &&
          hasTabletScrolledHeaderBody ? (
            <div data-testid="tablet-Product-test-id"> {headerBody}</div>
          ) : (
            <span className={styles['header-left-nav-container']}>
              <SiteLogo {...siteLogoData} />
              {/* TODO: Will be moved under SiteHeader CMS component once CMS data is available for ente site header */}
              {!showSearchOverlay && <NavigationBar {...navigationBarData} />}
            </span>
          )}
        </div>
        <div className={`${styles['header-right-nav']}  ${showSearchOverlay ? styles['jc-center'] : ''}`}>
          <SearchBar
            searchText={searchText}
            setSearchText={setSearchText}
            onSearch={suggestionHandler}
            openOverlay={() => setShowSearchOverlay(true)}
            expanded={showSearchOverlay}
          />
          {!showSearchOverlay && (
            <span className={styles['side-navigation-container']}>
              <HeaderItems
                HeaderItemsData={[
                  {
                    id: 'location-selector',
                    headerItemIcon: (
                      <span className={styles['header-right-nav-cart-icon']} data-testid="location-selector-icon-id">
                        <LocationSelector />
                      </span>
                    ),
                  },
                  {
                    id: 'mini-cart',
                    headerItemIcon: (
                      <span className={styles['header-right-nav-cart-icon']} data-testid="mini-cart-icon-id">
                        <GenericLink href={'/cart'} forceNative={false}>
                          <div className={styles['cart-icon-container']}>
                            <MiniCart
                              displayCount={0}
                              icon={<FAIcon iconName={'cart-shopping'} className={styles['mini-cart-icon']} />}
                            />
                          </div>
                        </GenericLink>
                      </span>
                    ),
                  },
                  {
                    id: 'me',
                    headerItemIcon: (
                      <MePanelDrawer
                        onMePanelClick={onMePanelClick}
                        cartListId={cartListId}
                        langHandler={langHandler}
                        locale={locale}
                        isLoggedIn={isLoggedIn}
                      />
                    ),
                  },
                ]}
              />
            </span>
          )}
        </div>
        {showSearchOverlay && <SearchCloseButton overlayCloseHandler={overlayCloseHandler} />}
      </header>
      {mobileView ? (
        ''
      ) : (
        <SearchOverlay
          onSuggestionClick={suggestionHandler}
          searchText={searchText}
          closeHandler={overlayCloseHandler}
          showOverlay={showSearchOverlay}
        />
      )}
    </div>
  );
};
export default SiteHeader;
